<script>
  import Sparkline from './Sparkline.svelte';

  export let value;
  export let trend;
  export let color = "black";
  export let tooltipFormatter = null;
</script>

<div>
  {value !== null ? value : "?"}
  {#if trend}
    <Sparkline data={trend} {color} enableTooltip {tooltipFormatter} />
  {/if}
</div>

<style>
  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 4px;
    width: 100%;
  }
</style>